import NewsDetail from "../../components/News/NewsDetail/NewsDetail";
import { getStrapiResponse } from "../../utils/utils.tsx";
import { useQuery } from "@tanstack/react-query";
import Page404 from "../../components/Page404/Page404.tsx";
import { useNavigate, useParams } from "react-router-dom";
import { Article_Array } from "../../types/api/article.ts";
import { useEffect } from "react";
import { updateSEO } from "../../utils/seo";

const fetchPageData = async ({
  queryKey,
}: {
  queryKey: string[];
}): Promise<Article_Array> => {
  const response = await getStrapiResponse(queryKey[0]);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

const NewsPage = ({ locale }: { locale?: string }) => {
  const navigate = useNavigate();
  const params = useParams();
  const localeParam = locale ? `&locale=${locale}` : "";
  const articleUrl = `/api/articles?customPopulate=nested&status=preview&filters[slug][$eq]=${
    params.slug ? params.slug : ""
  }${localeParam}`;

  const {
    data: pages,
    error,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [articleUrl],
    queryFn: fetchPageData,
  });

  const page = pages?.data?.[0];

  useEffect(() => {
    updateSEO(page?.seo); // Canonical will be set even if seo is undefined
  }, [page]);

  if (isLoading) return <div className="loading-block"></div>;
  if (isError) return <div>Error: {error.message}</div>;
  if (!pages) return <div>Global error: {pages}</div>;
  if (!pages.data.length) {
    navigate("/", { replace: true });
    return <Page404 locale={""} />;
  }

  return (
    <>
      <div className="content-block content-block_news">
        {page && <NewsDetail page={page} />}
      </div>
    </>
  );
};

export default NewsPage;
